import type { RightPanelView } from '../hooks/useRightPanelState'

export function getRightPanelRenderState({
  rightPanelView,
  hasItineraryData,
  hasTripListContent,
}: {
  rightPanelView: RightPanelView
  hasItineraryData: boolean
  hasTripListContent: boolean
}) {
  const isTimelineView = rightPanelView === 'timeline'
  const isListView = rightPanelView === 'list'

  return {
    shouldShowMap: rightPanelView === 'map',
    shouldShowTimelineEmptyState: isTimelineView && !hasItineraryData,
    shouldShowTripPlanCanvas: isTimelineView && hasItineraryData,
    shouldShowListEmptyState: isListView && !hasTripListContent,
    shouldShowListView: isListView && hasTripListContent,
  }
}
